import vStores, { webAdapter } from 'vstores';

export default vStores.create<{
  token: string;
  [key: string]: any;
}>({
  adapter: webAdapter,
  formatKey: (key) => `${process.env.NEXT_PUBLIC_STORAGE_PREFIX}-${key}`,
});
